import React from 'react';
import { Hero } from '../Hero/Hero';

export const References = () => {
	return (
		<div className="data-sources-page">
			<Hero slim title="Data Sources" eyebrow="References" />

			<div className="data-sources-body">
				{/* Introduction */}
				<section className="data-sources-intro">
					<p>
						This page lists all the data sources used in compiling the geofluid database, including research publications, open databases, and public repositories. The data is continuously updated as new datasets are contributed.
					</p>
				</section>

				{/* Sections for Data Sources */}
				<section className="data-sources-section">
					<h2>Geothermal Data Sources</h2>
					<ul>
						<li><a>Argonne Geothermal Geochemical Dataset. This data set was compiled in conjunction with the following report to the DOE Geothermal Technologies Program:  Clark, C.E., Harto, C.B., Sullivan, J.L. and M.Q. Wang. 2010. Water Use in the Development and Operation of Geothermal Power Plants. Prepared for the US DOE EERE Geothermal Technologies Program. Argonne National Laboratory.</a></li>
					</ul>
				</section>

				<section className="data-sources-section">
					<h2>Oilfield Brines</h2>
					<ul>
						<li><a>USGSPWDB v.2.0 - U.S. Geological Survey National Produced Waters Geochemical Database (ver. 3.0, December 2023), Energy Resources Program Headquarters Office</a></li>
					</ul>
				</section>

				<section className="data-sources-section">
					<h2>Hot Springs</h2>
						<ul>
							<li>
								<a
									href="https://doi.org/10.1016/j.gexplo.2015.08.011"
									target="_blank"
									rel="noopener noreferrer"
								>
									Awaleh, M. O., Hoch, F. B., Boschetti, T., Soubaneh, Y. D., Egueh, N. M., Elmi, S. A.,
									Mohamed, J., &amp; Khaireh, M. A. (2015). The geothermal resources of the Republic of Djibouti —
									II: Geochemical study of the Lake Abhe geothermal field. Journal of Geochemical Exploration,
									159, 129-147. https://doi.org/10.1016/j.gexplo.2015.08.011
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1134/s0742046309060025"
									target="_blank"
									rel="noopener noreferrer"
								>
									Bortnikova, S. B., Gavrilenko, G. M., Bessonova, E. P., &amp; Lapukhov, A. S. (2010). The
									hydrogeochemistry of thermal springs on Mutnovskii Volcano, southern Kamchatka. Journal of
									Volcanology and Seismology, 3(6), 388-404. https://doi.org/10.1134/s0742046309060025
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.chemgeo.2005.06.007"
									target="_blank"
									rel="noopener noreferrer"
								>
									Brugger, J., Long, N., McPhail, D. C., &amp; Plimer, I. (2005). An active amagmatic hydrothermal
									system: The Paralana hot springs, Northern Flinders Ranges, South Australia. Chemical Geology,
									222(1-2), 35-64. https://doi.org/10.1016/j.chemgeo.2005.06.007
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.geothermics.2020.101997"
									target="_blank"
									rel="noopener noreferrer"
								>
									Das, P., Maya, K., &amp; Padmalal, D. (2021). Hydrochemistry, geothermometry and origin of the low
									temperature thermal springs of South Konkan region, India. Geothermics, 90.
									https://doi.org/10.1016/j.geothermics.2020.101997
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1029/WR001i003p00415"
									target="_blank"
									rel="noopener noreferrer"
								>
									De Grys, A. (2010). Some observations on the hot springs of central Chile. Water Resources
									Research, 1(3), 415-428. https://doi.org/10.1029/WR001i003p00415
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.chemer.2021.125797"
									target="_blank"
									rel="noopener noreferrer"
								>
									Elenga, H. I., Tan, H., Su, J., &amp; Yang, J. (2021). Origin of the enrichment of B and alkali
									metal elements in the geothermal water in the Tibetan Plateau: Evidence from B and Sr
									isotopes. Geochemistry, 81(3). https://doi.org/10.1016/j.chemer.2021.125797
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.jvolgeores.2011.12.003"
									target="_blank"
									rel="noopener noreferrer"
								>
									Guo, Q., &amp; Wang, Y. (2012). Geochemistry of hot springs in the Tengchong hydrothermal areas,
									Southwestern China. Journal of Volcanology and Geothermal Research, 215-216, 61-73.
									https://doi.org/10.1016/j.jvolgeores.2011.12.003
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1007/s12517-015-2139-2"
									target="_blank"
									rel="noopener noreferrer"
								>
									Gurav, T., Singh, H. K., &amp; Chandrasekharam, D. (2015). Major and trace element concentrations
									in the geothermal springs along the west coast of Maharashtra, India. Arabian Journal of
									Geosciences, 9(1). https://doi.org/10.1007/s12517-015-2139-2
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.3390/w13020134"
									target="_blank"
									rel="noopener noreferrer"
								>
									Jawadi, H. A., Malistani, H. A., Moheghy, M. A., &amp; Sagin, J. (2021). Essential Trace Elements
									and Arsenic in Thermal Springs, Afghanistan. Water, 13(2). https://doi.org/10.3390/w13020134
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.chemer.2016.10.003"
									target="_blank"
									rel="noopener noreferrer"
								>
									Jayawardana, D. T., Udagedara, D. T., Silva, A. A. M. P., Pitawala, H. M. T. G. A., Jayathilaka,
									W. K. P., &amp; Adikaram, A. M. N. M. (2016). Mixing geochemistry of cold water around
									non-volcanic thermal springs in high-grade metamorphic terrain, Sri Lanka. Geochemistry, 76(4),
									555-565. https://doi.org/10.1016/j.chemer.2016.10.003
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.chemgeo.2012.08.019"
									target="_blank"
									rel="noopener noreferrer"
								>
									Kaasalainen, H., &amp; Stefánsson, A. (2012). The chemistry of trace elements in surface geothermal
									waters and steam, Iceland. Chemical Geology, 330-331, 60-85.
									https://doi.org/10.1016/j.chemgeo.2012.08.019
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.apgeochem.2015.02.003"
									target="_blank"
									rel="noopener noreferrer"
								>
									Kaasalainen, H., Stefánsson, A., Giroud, N., &amp; Arnórsson, S. (2015). The geochemistry of trace
									elements in geothermal fluids, Iceland. Applied Geochemistry, 62, 207-223.
									https://doi.org/10.1016/j.apgeochem.2015.02.003
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.marpolbul.2018.01.007"
									target="_blank"
									rel="noopener noreferrer"
								>
									Leal-Acosta, M. L., Shumilin, E., Mirlean, N., Baturina, E. L., Sanchez-Rodriguez, I.,
									Delgadillo-Hinojosa, F., &amp; Borges-Souza, J. (2018). Intertidal geothermal hot springs as a
									source of trace elements to the coastal zone: A case study from Bahia Concepcion, Gulf of
									California. Mar Pollut Bull, 128, 51-64. https://doi.org/10.1016/j.marpolbul.2018.01.007
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.jseaes.2015.11.021"
									target="_blank"
									rel="noopener noreferrer"
								>
									Liu, H., Guo, H., Xing, L., Zhan, Y., Li, F., Shao, J., Niu, H., Liang, X., &amp; Li, C. (2016).
									Geochemical behaviors of rare earth elements in groundwater along a flow path in the North
									China Plain. Journal of Asian Earth Sciences, 117, 33-51.
									https://doi.org/10.1016/j.jseaes.2015.11.021
								</a>
							</li>
							<li>
								<a
									href="https://doi.org/10.1016/j.chemgeo.2005.07.014"
									target="_blank"
									rel="noopener noreferrer"
								>
									McCarthy, K. T., Pichler, T., &amp; Price, R. E. (2005). Geochemistry of Champagne Hot Springs
									shallow hydrothermal vent field and associated sediments, Dominica, Lesser Antilles. Chemical
									Geology, 224(1-3), 55-68. https://doi.org/10.1016/j.chemgeo.2005.07.014
								</a>
							</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.earscirev.2018.09.008"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Minissale, A., Donato, A., Procesi, M., Pizzino, L., &amp; Giammanco, S. (2019). Systematic review
								of geochemical data from thermal springs, gas vents and fumaroles of Southern Italy for
								geothermal favourability mapping. Earth-Science Reviews, 188, 514-535.
								https://doi.org/10.1016/j.earscirev.2018.09.008
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.chemer.2013.06.002"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Morteani, G., Möller, P., Dulski, P., &amp; Preinfalk, C. (2014). Major, trace element and stable
								isotope composition of water and muds precipitated from the hot springs of Bolivia: Are the
								waters of the spring&#39;s potential ore forming fluids? Geochemistry, 74(1), 49-62.
								https://doi.org/10.1016/j.chemer.2013.06.002
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.jsames.2015.02.006"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Ormachea Muñoz, M., Bhattacharya, P., Sracek, O., Ramos Ramos, O., Quintanilla Aguirre, J.,
								Bundschuh, J., &amp; Maity, J. P. (2015). Arsenic and other trace elements in thermal springs and
								in cold waters from drinking water wells on the Bolivian Altiplano. Journal of South American
								Earth Sciences, 60, 10-20. https://doi.org/10.1016/j.jsames.2015.02.006
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.gexplo.2015.08.009"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Pantić, T. P., Birke, M., Petrović, B., Nikolov, J., Dragišić, V., &amp; Živanović, V. (2015).
								Hydrogeochemistry of thermal groundwaters in the Serbian crystalline core region. Journal of
								Geochemical Exploration, 159, 101-114. https://doi.org/10.1016/j.gexplo.2015.08.009
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.geothermics.2014.01.006"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Pope, J., &amp; Brown, K. L. (2014). Geochemistry of discharge at Waiotapu geothermal area, New
								Zealand – Trace elements and temporal changes. Geothermics, 51, 253-269.
								https://doi.org/10.1016/j.geothermics.2014.01.006
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.3390/resources12060068"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Sajkowski, L., Turnbull, R., &amp; Rogers, K. (2023). A Review of Critical Element Concentrations
								in High Enthalpy Geothermal Fluids in New Zealand. Resources, 12(6).
								https://doi.org/10.3390/resources12060068
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.gexplo.2021.106798"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Santos-Raga, G., Santoyo, E., Guevara, M., Almirudis, E., Pérez-Zárate, D., &amp; Yáñez-Dávila, D.
								(2021). Tracking geochemical signatures of rare earth and trace elements in spring waters and
								outcropping rocks from the hidden geothermal system of Acoculco, Puebla (Mexico). Journal of
								Geochemical Exploration, 227. https://doi.org/10.1016/j.gexplo.2021.106798
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1029/2020gc008919"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Scott, B. E., Newell, D. L., Jessup, M. J., Grambling, T. A., &amp; Shaw, C. A. (2020). Structural
								Controls on Crustal Fluid Circulation and Hot Spring Geochemistry Above a Flat‐Slab Subduction
								Zone, Peru. Geochemistry, Geophysics, Geosystems, 21(7).
								https://doi.org/10.1029/2020gc008919
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.apgeochem.2024.105910"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Shang, J., Liu, M., Cao, Y., Shi, H., &amp; Wei, X. (2024). Trace element geochemistry of
								high-temperature geothermal waters in the Yunnan-Tibet geothermal province, Southwest China.
								Applied Geochemistry, 162. https://doi.org/10.1016/j.apgeochem.2024.105910
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.1016/j.jvolgeores.2008.06.030"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Taran, Y., Rouwet, D., Inguaggiato, S., &amp; Aiuppa, A. (2008). Major and trace element
								geochemistry of neutral and acidic thermal springs at El Chichón volcano, Mexico. Journal of
								Volcanology and Geothermal Research, 178(2), 224-236.
								https://doi.org/10.1016/j.jvolgeores.2008.06.030
							</a>
						</li>
						<li>
							<a
								href={"https://doi.org/10.3390/w16050680"}
								target="_blank"
								rel="noopener noreferrer"
							>
								Yao, B., Zhou, X., Qiu, D., Du, J., He, M., Tian, J., Zeng, Z., Wang, Y., Yan, Y., Xing, G.,
								Cui, S., Li, J., Dong, J., Li, Y., &amp; Zhang, F. (2024). Geochemical Characteristics of Trace
								Elements of Hot Springs in the Xianshuihe–Xiaojiang Fault Zone. Water, 16(5).
								https://doi.org/10.3390/w16050680
							</a>
						</li>
						<li>
							<a>
								Zinabu G. M., P. N. J. G. (2003). Concentrations of heavy metals and related trace elements in
								some Ethiopian rift-valley lakes and their in-flows [Kluwer Academic Publishers]. Hydrobiologia,
								H. L. Golterman (ed.), Sediment–Water Interaction 13.(429), 171-178.
							</a>
						</li>
					</ul>
				</section>
			</div>
		</div>
	);
};

export default References;
